import React, { PureComponent } from 'react';

interface ExpandButtonProps {
  text: string;
  className: string;
  onClick: () => void;
}

export default class ExpandButton extends PureComponent<ExpandButtonProps> {

  render() {
    return (
      <div className="row">
        <button type="button" className={this.props.className} onClick={this.props.onClick}>{this.props.text}</button>
      </div>
    );
  }
}
